import { Link } from '@tanstack/react-router'
import cn from 'classnames'

export function NotFound({ children }: { children?: any }) {
  return (
      <div className={cn( 'max-w-8xl mx-auto text-center flex flex-col gap-4 justify-start items-stretch')}>
          <p>{children || <p>The page you are looking for does not exist.</p>}</p>
          <div className="flex items-center gap-2 flex-wrap mx-auto">
              {/*<button*/}
              {/*    onClick={() => window.history.back()}*/}
              {/*    className="btn btn-accent btn-dash"*/}
              {/*>*/}
              {/*    Go back*/}
              {/*</button>*/}
              <Link
                  to="/"
                  className="btn btn-ghost btn-accent"
              >
                  Homepage
              </Link>
          </div>
      </div>
  )
}
